<template>
	<footer class="container-fluid back-2 py-4">

		<div class="row">
			<div class="col-12">
				<div class="row justify-content-center">
					<div class="col-12 col-md-8 text-center"> <img
							src="../../assets/images/logo.png"
							:alt="altImg"
							class="img-fluid logo"
							ref="mainNavLogo"
						/></div>

					<div class="col-12 col-md-8 justify-content-center color-3 Regular text-center py-3">
						"VINCI UNO CHEF CON BIRRA MORETTI FILTRATA A FREDDO" <br>
						è un concorso a premi valido dal 01/03/2022 al 30/04/2022 <br>
						Per informazioni chiama il numero 02 94 7575 60 attivo tutti i giorni dalle 9:00 alle 13:00 <br>
						e dalle 14:00 alle 18:00 (esclusi i giorni festivi) oppure scrivi a vinciunacena@birramoretti.it
					</div>
					<div class="col-12  col-lg-6 d-flex flex-column flex-md-row justify-content-around">

						<div class="flex-basis-20 text-center">

							<a
								:href="privacyPolicy"
								class="white inv"
							>Informativa Privacy</a>

						</div>

						<div class="flex-basis-20 text-center">

							<a
								:href="cookiePolicy"
								class="white inv"
							>Informativa Cookie</a>

						</div>

						<div class="flex-basis-20 text-center">

							<a
								:href="regolamentoPolicy"
								class="white inv"
							>Regolamento</a>

						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="d-flex flex-column justify-content-center white">

			<div class="text-center">

				<img
					src="../../assets/images/logo.png"
					:alt="altImg"
					class="img-fluid logo"
					ref="mainNavLogo"
				/>
			</div>

			<div>

				<small><a
						:href="privacyPolicy"
						target="_blank"
						class="white"
					>Informativa Privacy</a>
				</small>

				<small>

					<a
						:href="cookiePolicy"
						target="_blank"
						class="white"
					>Informativa Cookie</a>
				</small>

				<small><a
						:href="regolamentoPolicy"
						target="_blank"
						class="white"
					>Regolamento</a>
				</small>
			</div>
		</div> -->

	</footer>
</template>


<script>
	import { sharedEnvMixin } from '../../mixins/sharedEnvMixin';

	export default {
		name: 'Footer',
		mixins: [sharedEnvMixin],
		mounted() {},
	};
</script>
